import type { IntlShape } from 'react-intl'
import type { ProductHeader, ProductFormInput } from './types'

export const productHeaders: ProductHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Numero',
				description: 'Table column header: Number',
			}),
		key: 'number',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Table column header: Code',
			}),
		key: 'code',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotenimike',
				description: 'Table column header: Product Name',
			}),
		key: 'productName',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotetyyppi',
				description: 'Table column header: Product Type',
			}),
		key: 'productType',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Myyntihinta',
				description: 'Table column header: Sales Price',
			}),
		key: 'salesPrice',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV %',
				description: 'Table column header: VAT Percentage',
			}),
		key: 'vatPercentage',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotesaldo',
				description: 'Table column header: Product Stock',
			}),
		key: 'productStock',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Varastoarvo',
				description: 'Table column header: Inventory Value',
			}),
		key: 'inventoryValue',
		show: true,
		sortable: true,
		type: 'number',
	},
]

export const productInformationHeaders: ProductFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Code',
			}),
		key: 'code',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ostohinta (EUR)',
				description: 'Purchase Price (EUR)',
			}),
		key: 'purchasePriceEUR',
		show: true,
		type: 'number',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'EAN-Koodi',
				description: 'EAN-Code',
			}),
		key: 'eanCode',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV-koodi',
				description: 'VAT-Code',
			}),
		key: 'vatCode',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotenimike',
				description: 'Product Name/Type',
			}),
		key: 'productName',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Myyntihinta (Netto) (EUR)',
				description: 'Sales Price (Net) (EUR)',
			}),
		key: 'salesPriceNetEUR',
		show: true,
		type: 'number',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Yksikkö',
				description: 'Unit',
			}),
		key: 'unit',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Myyntihinta (Brutto) (EUR)',
				description: 'Sales Price (Gross) (EUR)',
			}),
		key: 'salesPriceGrossEUR',
		show: true,
		type: 'number',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tyyppi',
				description: 'Type',
			}),
		key: 'type',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Automaattinen valuuttahinnoittelu',
				description: 'Automatic currency pricing',
			}),
		key: 'automaticCurrencyPricing',
		show: true,
		type: 'boolean',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ryhmä',
				description: 'Group',
			}),
		key: 'group',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Hälytysraja',
				description: 'Alert Limit',
			}),
		key: 'alertLimit',
		show: true,
		type: 'number',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Avainsanat',
				description: 'Keywords',
			}),
		key: 'keywords',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Hyllypaikka',
				description: 'Shelf Location',
			}),
		key: 'shelfLocation',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Myyntitili',
				description: 'Sales Account',
			}),
		key: 'salesAccount',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tariffi',
				description: 'Tariff',
			}),
		key: 'tariff',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimittaja',
				description: 'Supplier',
			}),
		key: 'supplier',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Paino (kg)',
				description: 'Weight (kg)',
			}),
		key: 'weightKG',
		show: true,
		type: 'number',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimittajan tuotekoodi',
				description: 'Supplier Product Code',
			}),
		key: 'supplierProductCode',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Alkuperämaa',
				description: 'Country of Origin',
			}),
		key: 'countryOfOrigin',
		show: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Additional Information',
			}),
		key: 'additionalInformation',
		show: true,
		type: 'string',
		fullWidth: true,
	},
]

export const productCurrencyHeaders: ProductFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Currency',
			}),
		key: 'currency',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'á-hinta',
				description: 'Unit Price',
			}),
		key: 'unitPrice',
		show: true,
		type: 'string',
	},
]

export const productContentHeaders: ProductFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Code',
			}),
		key: 'code',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotenimike',
				description: 'Product Name',
			}),
		key: 'productName',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Määrä',
				description: 'Quantity',
			}),
		key: 'quantity',
		show: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ostohinta',
				description: 'Purchase Price',
			}),
		key: 'purchasePrice',
		show: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Hintakerroin',
				description: 'Price Factor',
			}),
		key: 'priceFactor',
		show: true,
		type: 'number',
	},
]

export const languageHeaders: ProductFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kieli',
				description: 'Language',
			}),
		key: 'language',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotenimike',
				description: 'Product Name',
			}),
		key: 'productName',
		show: true,
		type: 'string',
	},
]

export const purchasePriceHeaders: ProductFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Currency',
			}),
		key: 'currency',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ostohinta',
				description: 'Purchase Price',
			}),
		key: 'purchasePrice',
		show: true,
		type: 'string',
	},
]
